import 'hammerjs'

export default class DocumentContents {
  constructor(element) {
    this.$el = $(element)
    this.$trigger = this.$el.find('.document-contents__collapse-btn')
    this.$topTrigger = this.$el.find('document-contents__head')
    this.init();
  }

  init() {
    const {$el, $trigger, $topTrigger} = this

    $trigger.on('click', function (e) {
      $el.toggleClass('active')
    })

    document.querySelectorAll('.document-contents__head').forEach((elem) => {
      const hammerEl = new Hammer(elem);

      hammerEl.get('swipe').set({ direction: Hammer.DIRECTION_ALL });

      hammerEl.on('swipedown', function(ev) {
        $el.removeClass('active')
      });
    })
  }
}
